import { useAct } from 'FlowTaker/store'
import DonateAction from './Actions/DonateAction'
import SurveyAction from './Actions/SurveyAction'
import ShareAction from './Actions/ShareAction'
import RedirectAction from './Actions/RedirectAction'
import LundaAction from './Actions/LundaAction'
import EmailToTargetAction from './Actions/EmailToTargetAction'
import CustomAction from './Actions/CustomAction'
import './PageContainer.scoped.scss'
import FundraiseUpAction from './Actions/FundraiseUpAction'

import AdminHeader from 'FlowTaker/components/AdminHeader'
import useLanguage from 'FlowBuilder/hooks/useLanguageFlow'
import LanguageSwitcher from './LanguageSwitcher'

export default function PageContainer({ isPreview, flowId, forget, oneClickSubmit }) {
  const act = useAct()
  const actionId = useSel((s) => s.taker.flowTaker.currentActionId)
  const action = useSel((s) => s.taker.flow.actions.find((a) => a.id === actionId) || {})

  const { kind, surveyId } = action
  const [loading, setLoading] = useState(true)
  const language = useLanguage();

  useEffect(() => {
    act.taker.load(flowId, { forget, oneClickSubmit, language }).finally(() => {
      setLoading(false)
      if (oneClickSubmit && window && window.history && window.location) {
        const url = new URL(window.location.href)
        url.searchParams.delete('oneClickSubmit')
        window.history.replaceState({}, '', url.toString())
      }
    })
  }, [act, flowId, forget])

  useEffect(() => {
    if (isPreview) {
      const onUnmount = act.taker.setupPreviewPostMessage()
      return onUnmount
    }
  }, [isPreview])

  function Content() {
    if (kind === 'survey') {
      return <SurveyAction actionId={actionId} surveyId={surveyId} />
    } else if (kind === 'share') {
      return <ShareAction actionId={actionId} />
    } else if (kind === 'redirect') {
      return <RedirectAction actionId={actionId} />
    } else if (kind === 'lunda') {
      return <LundaAction actionId={actionId} />
    } else if (kind === 'fundraise_up') {
      return <FundraiseUpAction actionId={actionId} />
    } else if (kind === 'email_to_target') {
      return <EmailToTargetAction actionId={actionId} />
    } else if (kind === 'donate') {
      return <DonateAction actionId={actionId} />
    } else if (kind === 'custom') {
      return <CustomAction actionId={actionId} />
    } else {
      return <div>Unknown action kind: {kind}</div>
    }
  }

  if (loading || action.length === 0) {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <SvgCircLoading />
      </div>
    )
  }

  return (
    <div>
      <AdminHeader />
      { !isPreview && <LanguageSwitcher /> }
      <Content />
    </div>
  )
}
